export default {
  install(Vue) {
    Vue.mixin({
      data: function () {
        return {
          $token: null
        };
      },
      methods: {
        $alertMsg(content, title = '', getButtonEvent = () => {}, btnName) {
          this.$eventBus.$emit('DialogPopup', {
            useDialog: true,
            messageHTML: title ? `<dl class="txt"><dt>${title}</dt><dd>${content}</dd></dl>` : `<p class="txt">${content}</p>`,
            getBtnName: !btnName ? '확인' : btnName,
            getButtonEvent: () => getButtonEvent()
          });
        },
        $confirmMsg(title, content, getButtonEvent = () => {}, btnName, getLeftBtnEvent = () => {}, leftBtnName, useReverse = false) {
          this.$eventBus.$emit('DialogPopup', {
            useDialog: true,
            getBtnCount: 2,
            getBtnName: !btnName ? '저장' : btnName,
            getLeftBtnName: !leftBtnName ? '취소' : leftBtnName,
            getButtonEvent: () => getButtonEvent(),
            getLeftBtnEvent: () => getLeftBtnEvent(),
            messageHTML: title ? `<dl class="txt"><dt>${title}</dt><dd>${content}</dd></dl>` : `<p class="txt">${content}</p>`,
            useReverse
          });
        }
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/GlobalEvent.js